var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SlidingPanel",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isHelpPanelOpen,
          expression: "isHelpPanelOpen"
        }
      ],
      ref: "HelpPanel",
      staticClass: "powerbar-help-panel",
      attrs: {
        id: "HelpPanel",
        enterFrom: "right",
        isFullHeight: false,
        panelWidth: "270"
      }
    },
    [
      _c("p", { staticClass: "powerbar-help-panel__group-heading" }, [
        _vm._v("Help")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "powerbar-settings-panel__links-group" },
        _vm._l(_vm.helpMenuLinks, function(link, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "powerbar-settings-panel__links-group-item"
            },
            [
              _c("a", {
                staticClass: "powerbar-settings-panel__link",
                attrs: { href: link.path, target: link.target },
                domProps: { innerHTML: _vm._s(link.label) },
                on: {
                  click: function($event) {
                    return _vm.onClick(link.label)
                  }
                }
              })
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }